export default __webpack_public_path__ + "static/media/eye - inactive.484d85f3.svg";